export default __webpack_public_path__ + "static/media/nova-adesao.a35cee4b.svg";